import { Button, makeStyles, Box } from "@material-ui/core";
import React from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import { backend } from "../../api";

const useStyles = makeStyles((theme) => ({
  root: {
    padding: "10px",
    border: `1px solid ${theme.palette.secondary.dark}`,
    textDecoration: "none",
    textAlign: "center",
    transition: "0.2s linear",
    "&:hover": {
      boxShadow: `0px 0px 15px 1px ${theme.palette.secondary.dark}`,
    },
  },
  coverImg: {
    width: "100%",
    height: 250,
    objectFit: "contain",
  },
  imgContainer: {
    width: "90%",
    margin: "0 auto",
  },
  bookTitle: {
    fontSize: "20px",
    fontWeight: 700,
    lineHeight: "24px",
    marginBottom: "10px",
  },
  price: {
    fontSize: "18px",
    fontWeight: "600",
    marginTop: "10px",
  },
  cartBtn: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.secondary.light,
    fontSize: "12px",
    fontWeight: "600",
    borderRadius: "2px",
    padding: "10px 0",
    width: "110px",
    "&:hover": {
      backgroundColor: theme.palette.secondary.light,
      color: theme.palette.primary.main,
    },
  },
  toastBtn: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.secondary.light,
    textDecoration: "none",
    marginLeft: "20px",
  },
}));

function AdverBookCard(props) {
  const { book } = props;
  const classes = useStyles();
  const { currentUser } = useSelector((state) => state.auth);
  const download = async () => {
    try {
      await backend.post("/adverbook/download", {
        adverbook: book,
        book: book._id,
        user: currentUser._id,
      });
      toast.success("Successfully downloaded. Please visit your dashboard");
    } catch (err) {
      toast.error(err.response ? err.response.data.message : "Error occured");
    }
  };

  const downloadBook = async () => {
    await download();
  };

  return (
    <div className={classes.root}>
      {book?.book_cover && (
        <Link
          to={`/kleverbook/${book._id}`}
          style={{ textDecoration: "none", color: "black" }}
        >
          <Box className={classes.imgContainer}>
            <img src={book?.book_cover} className={classes.coverImg} />
          </Box>
        </Link>
      )}
      <h2 className={classes.bookTitle}>{book?.book_title}</h2>
      {currentUser.user?.role == "customer" ? (
        <Button
          className={classes.cartBtn}
          onClick={() => {
            downloadBook();
          }}
        >
          Download Now
        </Button>
      ) : (
        <Button
          className={classes.cartBtn}
          onClick={() => toast.warn("Please Login as Customer.")}
        >
          Download Now
        </Button>
      )}
    </div>
  );
}

export default AdverBookCard;
